import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './assets/css/style.css'
import {getRequest, postRequest, putRequest, deleteRequest, uploadFileRequest, resolveImgUrl, resolveContentHtml} from "@/api/api";

Vue.prototype.getRequest = getRequest;
Vue.prototype.postRequest = postRequest;
Vue.prototype.putRequest = putRequest;
Vue.prototype.deleteRequest = deleteRequest;
Vue.prototype.uploadFileRequest = uploadFileRequest;
Vue.prototype.resolveImgUrl = resolveImgUrl;
Vue.prototype.resolveContentHtml = resolveContentHtml;


Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
